module.exports = __webpack_public_path__ + "static/img/main3_3.256fb270.png";